import { render } from "./DaftarQuickStatus.vue?vue&type=template&id=d71eb49e"
import script from "./DaftarQuickStatus.vue?vue&type=script&lang=js"
export * from "./DaftarQuickStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__